import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'
import { ICON_PATHS } from './paths'

export const Doctor = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="doctor icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d={ICON_PATHS.doctor}
    />
  </svg>
)
